import { Koi } from '@ksyos/koi';
import { AbortProcessReasons } from '@common/enums';

export type OsasCloseUnfinishedExaminationData = {
    reason: AbortProcessReasons | null;
};

export const osasCloseUnfinishedExaminationDraftSchema = Koi.object({
    reason: Koi.koi().enum(AbortProcessReasons).allow(null),
});

export const osasCloseUnfinishedExaminationFinalSchema = Koi.object({
    reason: Koi.koi().enum(AbortProcessReasons),
});
